<script setup>
</script>

<template>
  <div class="flex items-center w-screen h-screen bg-gray-50">
    <router-view />
  </div>
</template>
